import useGeneralConfigurationSimpleForm from './useGeneralConfigurationSimpleForm'

export default useGeneralConfigurationSimpleForm
